// extracted by mini-css-extract-plugin
module.exports = {"grouped_images":"styles_grouped_images__A0Ejw","center_button":"styles_center_button__9eZ8r"};